import {Nullish} from 'shared/web';

export type CatalogFilter = {
  branchId: string | null;
  supplierId: string | Nullish;
  manufacturerId: string;
  manufacturerNumber: string;
};
